import { palette } from '../../../styles/variables'

export const pricingPage = {
  commonPromoBackground: palette.darkGray,
  promotionText: 'bf_pricing_page_heading',
  radioGroupPromoText: 'black_friday',
  showRadioGroupPromoSearchIcon: true,
  promoBadgeColor: palette.darkGray,
  promoBadgeBackground: palette.orange,
  promoBadgeText: 'black_friday',
  yearlyPriceColor: palette.darkGray,
}
